module.exports = __webpack_public_path__ + "media/brands/subaru-fe06f8f6.png";